(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-search-area.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-search-area.js');

'use strict';

const {
  useEffect,
  useRef,
  useState
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  ReactButton: Button,
  ReactIcon: Icon,
  ReactPaper: Paper
} = svs.ui;
const {
  login
} = svs.components.customer_login;
const {
  selectSearchFilters
} = svs.components.marketplaceShared.coOpPlay.selectors;
const {
  updateFilterAction
} = svs.components.marketplaceShared.coOpPlay.actions;
const {
  FILTER_QUERY_NAME,
  FILTER_FRACTION_PRICE
} = svs.components.marketplaceShared.sharedConstants.constants;
const {
  SearchFilterName
} = svs.components.marketplaceShared.searchFilters;
const {
  RetailerSearchBottomSheet
} = svs.components.tipsen;
const {
  trackEvent
} = svs.components.analytics;
const {
  getLogger
} = svs.core.log;
const logger = getLogger('tipsen:co-op-play-marketplace:retailer');
const {
  PriceRange,
  Range,
  radioOptions
} = svs.components.tipsen.utils.range;
const RetailerSearchArea = _ref => {
  let {
    branding,
    onChange,
    productId
  } = _ref;
  const dispatch = useDispatch();
  const observerRef = useRef(null);
  const focusRef = useRef(null);
  const isUserLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const updateFilter = filter => dispatch(updateFilterAction(filter));
  const [showPriceFilter, setShowPriceFilter] = useState(false);
  const {
    fractionPriceMin
  } = useSelector(selectSearchFilters);
  const productName = svs.utils.products.getDisplayName(productId);
  const [currentRange, setCurrentRange] = useState(() => {
    const entry = Object.entries(PriceRange).find(_ref2 => {
      let [, {
        selectedMin
      }] = _ref2;
      return selectedMin === fractionPriceMin;
    });
    const rangeKey = entry ? entry[0] : Range.RANGE_ALL;
    return Number(rangeKey);
  });

  const trackPriceFilter = value => {
    const option = radioOptions.find(item => item.value === value);
    if (!option) {
      logger.debug('Price filter not found', value);
      return;
    }
    trackEvent({
      category: 'poolspel',
      action: "Share price filter ".concat(productName),
      opt_label: option.label
    });
  };

  const onPriceChange = value => {
    const {
      selectedMin,
      selectedMax
    } = PriceRange[value];
    setCurrentRange(value);
    updateFilter({
      key: FILTER_FRACTION_PRICE,
      value: {
        selectedMin,
        selectedMax
      }
    });

    if (value !== Range.RANGE_ALL) {
      trackPriceFilter(value);
    }
  };
  const ActiveFilter = () => {
    if (currentRange === Range.RANGE_ALL) {
      return null;
    }
    const {
      selectedMin,
      selectedMax
    } = PriceRange[currentRange];
    return React.createElement(Button, {
      "aria-label": "Ta bort filter f\xF6r andelspris",
      className: "btn-filter-active",
      onClick: () => onPriceChange(Range.RANGE_ALL),
      tabIndex: 0
    }, React.createElement("span", {
      className: "btn-link-text"
    }, React.createElement(Icon, {
      icon: "close",
      size: "200"
    }), React.createElement("span", {
      className: "btn-text"
    }, currentRange === Range.RANGE_1000_UP ? "+".concat(selectedMin, " kr") : "".concat(selectedMin, " - ").concat(selectedMax, " kr"))));
  };
  const searchQuery = useSelector(state => {
    var _state$CoOpPlayFilter;
    return (state === null || state === void 0 || (_state$CoOpPlayFilter = state.CoOpPlayFilter) === null || _state$CoOpPlayFilter === void 0 ? void 0 : _state$CoOpPlayFilter.searchName) || '';
  });
  useEffect(() => {
    const intersectionCallback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const btn = entry.target.querySelector('button');
          btn === null || btn === void 0 || btn.focus();
        } else if (focusRef.current) {
          requestAnimationFrame(() => {
            focusRef.current.focus();
            focusRef.current = null;
          });
        }
      });
    };
    observerRef.current = new IntersectionObserver(intersectionCallback, {
      root: document.querySelector('.js-drawer'),
      rootMargin: '0px',
      threshold: 1.0
    });
    requestAnimationFrame(() => {
      observerRef.current.observe(document.querySelector('.js-drawer'));
    });
    return () => {
      var _observerRef$current;
      (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 || _observerRef$current.disconnect();
    };
  }, []);
  return React.createElement("section", null, React.createElement(Paper, {
    branding: "sport",
    className: "co-op-play-container co-op-play-filters"
  }, React.createElement("div", {
    className: "co-op-play-filters-inner"
  }, React.createElement("form", {
    "aria-label": "Filtrering av andelsspel"
  }, React.createElement("div", {
    className: "search-input search-input-".concat(branding)
  }, React.createElement(SearchFilterName, {
    filterNameKey: FILTER_QUERY_NAME,
    nameSearchQuery: searchQuery,
    updateFilter: onChange
  })), React.createElement("div", null, React.createElement("div", {
    className: "co-op-play-filters-fractions align-center f-550"
  }, React.createElement(Button, {
    block: true,
    className: "btn-filter-price",
    onClick: () => {
      focusRef.current = document.activeElement;
      setShowPriceFilter(true);
    }
  }, React.createElement("span", {
    className: "btn-link-text"
  }, React.createElement(Icon, {
    icon: "filter",
    size: "200"
  }), React.createElement("span", {
    className: "btn-text"
  }, "Filter f\xF6r andelspris"))), React.createElement(ActiveFilter, null)))))), !isUserLoggedIn && React.createElement(Paper, {
    branding: "sport",
    className: "co-op-play-container co-op-play-login"
  }, React.createElement("div", {
    className: "co-op-play-login-inner"
  }, React.createElement("div", {
    className: "co-op-play-login-content"
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "login",
    size: "600"
  }), React.createElement("span", {
    className: "h4"
  }, "Logga in f\xF6r att visa spel fr\xE5n dina ombud!")), React.createElement(Button, {
    block: true,
    className: "btn-".concat(branding),
    inverted: true,
    onClick: login
  }, "Logga in"))), React.createElement(RetailerSearchBottomSheet, {
    currentRange: currentRange,
    isVisible: showPriceFilter,
    onChange: value => onPriceChange(value),
    onClose: () => setShowPriceFilter(false),
    productId: productId
  }));
};
RetailerSearchArea.defaultProps = {
  branding: 'sport'
};
setGlobal('svs.components.tipsen.RetailerSearchArea', RetailerSearchArea);

 })(window);